// extracted by mini-css-extract-plugin
export var root = "forgot-password-module--root--5347b";